import React from 'react';

function DocumentLargeNormalSVG() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 6C3 3.79086 4.79086 2 7 2H15L18 5.5L21 8.64886V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V6Z"
        fill="#C3C2C7"
      />
      <path d="M16.3999 9.4H20.5031C20.7776 9.4 21.0001 9.17747 21.0001 8.90296C21.0001 8.31418 20.8258 7.73858 20.4992 7.24869L20.3249 6.98725C19.4439 5.66565 18.4344 4.43431 17.3113 3.31116L16.807 2.80686C16.2903 2.29023 15.5896 2 14.859 2C14.6055 2 14.3999 2.20556 14.3999 2.45913V7.4C14.3999 8.50457 15.2953 9.4 16.3999 9.4Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 18C6 17.4477 6.44772 17 7 17H17C17.5523 17 18 17.4477 18 18C18 18.5523 17.5523 19 17 19H7C6.44772 19 6 18.5523 6 18Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 14C6 13.4477 6.44772 13 7 13H10C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15H7C6.44772 15 6 14.5523 6 14Z"
      />
      <path d="M7 6H10" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export default DocumentLargeNormalSVG;
